import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridCell } from 'mailup-web-components'
import { useRecoilValue } from 'recoil'

import BoxMessageInfo from './BoxMessageInfo'
import BoxSenderInfo from './BoxSenderInfo'
import { pageState } from 'Pages/EmailSendingWizard/recoil/state/page'

const BoxInfo = ({ idMessage }) => {
  const { wizardStep } = useRecoilValue(pageState)

  return (
    <Grid cols={2}>
      <GridCell>
        <BoxMessageInfo idMessage={idMessage} />
      </GridCell>
      <GridCell>{wizardStep === 2 && <BoxSenderInfo />}</GridCell>
    </Grid>
  )
}

BoxInfo.propTypes = {
  idMessage: PropTypes.number
}

export default BoxInfo
